import { StepNavigationSwitch } from '../../atoms/step-navigation-switch';
import { ShareInMessageGenericNavigation } from './navigation/share-in-message-generic-navigation';
import { ShareInMessageBody } from './share-in-message-body';
import { ShareInMessageProps } from './share-in-message.types';

export const ShareInMessageNavigationSwitch = (parentProps: ShareInMessageProps) => {
  return (
    <StepNavigationSwitch body={ShareInMessageBody} generic={ShareInMessageGenericNavigation} extra={parentProps} />
  );
};
